"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogContentText_1 = __importDefault(require("@material-ui/core/DialogContentText"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const Modal = (props) => {
    const { isVisible, modalText, titleText, cancelText, confirmText, onCancel, onConfirm } = props;
    return (react_1.default.createElement(Dialog_1.default, { open: isVisible, onClose: onCancel },
        titleText && (react_1.default.createElement(Box_1.default, null,
            react_1.default.createElement(DialogTitle_1.default, null,
                react_1.default.createElement(Box_1.default, null,
                    react_1.default.createElement(Typography_1.default, { variant: "subtitle1" }, titleText))),
            react_1.default.createElement(Divider_1.default, null))),
        react_1.default.createElement(DialogContent_1.default, null,
            react_1.default.createElement(Box_1.default, { pt: 2 },
                react_1.default.createElement(DialogContentText_1.default, null, modalText))),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(DialogActions_1.default, null,
            cancelText && (react_1.default.createElement(Button_1.default, { variant: "contained", color: "secondary", onClick: onCancel, style: { maxHeight: '30px', minWidth: '160px' } }, cancelText)),
            confirmText && (react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: onConfirm, style: { maxHeight: '30px' } }, confirmText)))));
};
Modal.propTypes = {
    isVisible: prop_types_1.default.bool.isRequired,
    modalText: prop_types_1.default.any.isRequired,
    titleText: prop_types_1.default.string,
    cancelText: prop_types_1.default.string,
    confirmText: prop_types_1.default.string,
    onCancel: prop_types_1.default.any,
    onConfirm: prop_types_1.default.any,
};
exports.default = Modal;
